var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "rep-detail",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "columns is-multiline" }, [
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("RelatedDocumentDetails", {
              ref: "RelatedDocumentDetailsComponent",
              attrs: {
                disabled: _vm.isLoading || _vm.stamped,
                "is-loading": _vm.isLoading,
                inline: true
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _vm.paymentsLoaded
              ? _c("Payments", {
                  attrs: {
                    disabled: _vm.isLoading || _vm.stamped,
                    "is-loading": _vm.isLoading
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("CfdisRelatedReplacement", {
              attrs: {
                "replacement-type": "replacementRep",
                disabled: _vm.isLoading || _vm.stamped
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "column is-12 action-buttons" }, [
          _vm.stamped || _vm.canceled
            ? _c("div", { staticClass: "field is-grouped" }, [
                _vm.stamped && !_vm.canceled
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-info",
                          class: { "is-loading": _vm.isLoading }
                        },
                        [
                          _vm._v(
                            "\n            Complemento de Pago Timbrado\n          "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm.canceled
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-danger",
                          class: { "is-loading": _vm.isLoading }
                        },
                        [
                          _vm._v(
                            "\n            Complemento de Pago Cancelado\n          "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.isLoading },
                        attrs: {
                          disabled: _vm.isLoading,
                          to: { name: "RepList" }
                        }
                      },
                      [_vm._v("\n            Regresar\n          ")]
                    )
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "field is-grouped" }, [
                _c("p", { staticClass: "control" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      class: { "is-loading": _vm.isLoading },
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        click: function($event) {
                          return _vm.setStamp(false)
                        }
                      }
                    },
                    [_vm._v("\n            Guardar\n          ")]
                  )
                ]),
                _c("p", { staticClass: "control" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-success",
                      class: { "is-loading": _vm.isLoading },
                      attrs: { type: "submit", disabled: _vm.isLoading },
                      on: {
                        click: function($event) {
                          return _vm.setStamp(true)
                        }
                      }
                    },
                    [_vm._v("\n            Guardar y Timbrar\n          ")]
                  )
                ]),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.isLoading },
                        attrs: {
                          disabled: _vm.isLoading,
                          to: { name: "RepList", query: { size: 20, page: 1 } }
                        }
                      },
                      [_vm._v("\n            Regresar\n          ")]
                    )
                  ],
                  1
                )
              ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }